export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/teacher/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/teacher/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/sku/teacher/queryByPhone`,
                data
            });
        },
        saveInfo(data) {
            return http.json({
                url: `/sku/teacher/save`,
                data
            })
        },
        saveTeacher(data) {
            return http.json({
                url: `/sku/teacher/saveTeacher`,
                data
            })
        },

        getOne(data) {
            return http.json({
                url: `/sku/teacher/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/teacher/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/sku/teacher/updateState`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/teacher.js